<script>
  import {subNavigation,ServiceMenu,RatesMenu,BeginnerMenu,SupportMenu,EffortMenu,ContentsMenu,FooterCommon} from "@util/constant.js"
  const logo_x = "/assets_default/icons/sns/logo_x-white.svg"
  const logo_facebook = "/assets_default/icons/sns/logo_facebook-white.svg"
  const logo_instagram = "/assets_default/icons/sns/logo_instagram-white.svg"
  const logo_youtube = "/assets_default/icons/sns/logo_youtube-white.svg"
  const logo_note = "/assets_default/icons/sns/logo_note-white.svg"
  const logo_mng = "/assets_default/icons/logo-white.svg"
  import { fly } from 'svelte/transition';

  const footerNavText = [
    {
      class: 'service',
      wrapp:[{
        label: 'サービス',
        column: [
          {
            title: 'サービス一覧',
            link: '/service/',
            Menu:ServiceMenu
          }
        ]
      }]
    },
    {
      wrapp:[{
        label: '金利・手数料',
        column: [
          {
            Menu:RatesMenu
          }
        ]
      },
      {
        column: [
          {
            Menu: [
              {
                column1: true,
                gapadjust: true,
                label: 'キャンペーン・プログラム',
                href: '/campaign/',
              }
            ]
          }
        ]
      },
      {
        label: '初めての方へ',
        column: [
          {
            Menu:BeginnerMenu
          }
        ]
      },
      {
        label: 'みんなの銀行の取組み',
        column: [
          {
            Menu:EffortMenu
          }
        ]
      },
      {
        label: 'お役立ちコンテンツ',
        column: [
          {
            Menu: ContentsMenu
          }
        ]
      },
      {
        label: 'サポート',
        column: [
          {
            Menu:SupportMenu
          },
        ]
      }]
    },
    {
      wrapp:[{
        label: '企業について',
        column: [
          {
            Menu:subNavigation
          },
        ]
      },{
        label: '利用規約・ポリシー',
        link:"https://corporate.minna-no-ginko.com/policy-and-term-of-use/"
      }],
      footerSNS:[
        {
          link: 'https://x.com/minnano_ginko',
          icon: logo_x,
          alt: "Xロゴアイコン",
        },
        {
          link: 'https://www.facebook.com/minnanoginko',
          icon: logo_facebook,
          alt: "facebookロゴアイコン",
        },
        {
          link: 'https://www.instagram.com/minnano_ginko_official',
          icon: logo_instagram,
          alt: "instagramロゴアイコン",
        },
        {
          link: 'https://www.youtube.com/@minnano_ginko',
          icon: logo_youtube,
          alt: "youtubeロゴアイコン",
        },
        {
          link: 'https://note.minna-no-ginko.com/',
          icon: logo_note,
          alt: "noteロゴアイコン",
        }
      ]
    }
  ];
  let y = $state(0)
  let x = $state(0)
  let BrowserHeight = $state(0)


</script>

<svelte:window bind:innerWidth={y} bind:scrollY={x} />

<footer class="owd-footer" id="owd-footer">
  <div class="owd-footer-inner">
    {#each footerNavText as footernav}
    <div class="owd-footer-section owd-footer-section:nav">
      <ul class="owd-footer-section:nav:section">
        {#each footernav.wrapp as nav}
        <li class="owd-footer-section:block">
          {#if nav.link}
           <p class="owd-caption spacing:bottom:24" style="opacity:1"><a href="{nav.link}" target="_blank" class="text-color:white">{nav.label}</a></p>
          {:else}
            <p class="owd-caption spacing:bottom:24"><strong>{nav.label}</strong></p>
          {/if}
          {#if nav.column}
          <ul class="owd-footer-section:column">
          {#each nav.column as column}
            {#if column.title}
              <p class="owd-heading:05"><a href="{column.link}">{column.title}</a></p>
            {/if}
            {#each column.Menu as item}
              {#if item.label !== "ユーザーガイド" && item.label !== "セキュリティ"}
              <li class={`owd-footer-section:column:items ${item.column1 ? 'owd-footer-section:column:items:column1' : ''} ${item.gapadjust ? 'owd-footer-section:column:items:gapadjust' : ''}`}>
                {#if item.href}
                <p class="owd-heading:05">
                  <a href="{item.href}" target="{item.blank ? '_blank' : undefined}">{item.label}</a>
                </p>
                {#if item.label == "みんなの銀行とは"}
                  <p class="owd-heading:05" style="margin-bottom: 24px; margin-top: 24px; "><a href={BeginnerMenu[2].href}>{BeginnerMenu[2].label}</a></p>
                  <p class="owd-heading:05"><a href={BeginnerMenu[3].href}>{BeginnerMenu[3].label}</a></p>
                {/if}
                {:else}
                  <p class="owd-heading:05">{item.label}</p>
                {/if}
                {#if item.childMenu}
                <ul class="owd-footer-section:column:items:child">
                  {#each item.childMenu as child}
                  <li><p class="owd-caption"><a href="{child.href}">{child.label}</a></p></li>
                  {/each}
                </ul>
              {/if}
            </li>
             {/if}
            {/each}
          {/each}
          </ul>
          {/if}
        </li>
        {/each}
      </ul>
      {#if footernav.footerSNS}
      <div class="owd-footer-section:campany">
        <a href="/">
          <img class="mng-logo" src="{logo_mng}" width="200" height="26" alt="Minna no Ginko">
        </a>
        <ul class="owd-footer-section:nav:section:sns">
          {#each footernav.footerSNS as sns}
          <li>
            <a href="{sns.link}" target="_blank" rel="noopener noreferrer">
              <img src={sns.icon} alt="{sns.alt}">
            </a>
          </li>
          {/each}
        </ul>
        <p class="owd-information adjust-line-height">{@html FooterCommon.company}</p>
      </div>
      {/if}
    </div>
    {/each}
    <div class="owd-footer-section owd-footer-section:copylight">
      <p class="owd-information">{@html FooterCommon.copylight}</p>
    </div>
  </div>
</footer>
{#if x > 1280}
<div class="owd-button-pagetop-wrap" transition:fly={{y: 100}}>
  <a href="#" class="owd-button-pagetop">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M6.414 15.414L12 9.828L17.586 15.414L19 14L12 7L5 14L6.414 15.414Z" fill="black"/>
    </svg>
  </a>
</div>
{/if}

<style lang="scss">


.owd-footer{
  width: 100%;
  background-color: var(--light-gray);
  color: var(--primary-white);
  &-inner{
    width: 100%;
    max-width: 504px;
    margin: 0 auto;
    padding: 40px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    background-color: var(--primary-black);
    a{
      @include g.hover-text-decoration($color: var(--primary-white), $offset: .5em);
    }
  }
  @include g.footer-breakpoint {
    background-color: var(--primary-black);
    &-inner{
      max-width: 1280px;
      flex-direction: row;
      align-items: flex-start;
      justify-content: center;
      flex-wrap: wrap;
      padding: 40px 80px;
      gap: 40px;
    }
  }
  .owd-footer-section{
    width: 100%;
    // max-width: 342px;
    &:first-of-type{
      li{
        &:first-of-type{
          .owd-heading\:05{
            width: 100%;
          }
        }
      }
    }
    &:nth-of-type(3){
      .owd-footer-section\:nav\:section {
        li{
          &:last-of-type{
            padding-bottom: 0;
            border-bottom: none;
            p{
              margin-bottom: 0;
            }
          }
        }
      }
    }
    @include g.footer-breakpoint {
      max-width: none;
      width: calc((1280/347)*100%);
      &:first-of-type{
        width: calc((1280/258)*100%);
        max-width: 258px;
        .owd-heading\:05{
          width: 100%;
        }
        .owd-footer-section{
          &\:column{
            gap: 32px;
            &\:items{
              width: 100%;
            }
          }
        }
      }
      &:nth-of-type(2){
        max-width: 347px;
      }
      &:nth-of-type(3){
        max-width: 347px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-self: stretch;
        ul{
          li{
            &:last-of-type{
              padding-bottom: 0;
              border-bottom: none;
              p{
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
    &\:nav{
      display: flex;
      flex-direction: column;
      gap: 40px;
      @include g.footer-breakpoint {
        max-width: 1120px;
      }
      &\:section{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 24px;
        &\:sns{
          display: flex;
          align-items: flex-start;
          gap: 16px;
          margin-bottom: 40px;
          li{
            width: 30px;
          }
        }
      }
      @include g.footer-breakpoint {
        flex-direction: row;
        &\:section{
          &:last-of-type{
            li{
              &:last-of-type{
                padding-bottom: 0;
                border-bottom: none;
              }
            }
          }
        }
      }
    }
    &\:block{
      width: 100%;
      padding-bottom: 24px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.20);
      >.owd-caption{
        opacity: .7;
      }
      &\:last{
        padding-bottom: 0;
        border-bottom: none;
        .owd-heading\:05{
          margin-bottom: 0;
        }
      }
    }
    &\:column{
      display: flex;
      align-items: flex-start;
      $section-block-gap: 24px;
      gap: $section-block-gap;
      align-self: stretch;
      flex-wrap: wrap;
      a {
        font-weight: inherit;
        color: inherit;
      }
      &\:title{
        width: 100%;
      }
      &\:items{
        width: calc(50% - (24px/2));
        &\:child{
          margin-top: 16px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 16px;
          li{
            margin-left: 12px;
            display: flex;
            align-items: center;
            &:before{
              content: "";
              width: 4px;
              margin-right: 8px;
              height: 1px;
              background: white;
              display: inline-block;
            }
          }
        }
        &\:column1{
          width: 100%;
        }
        &\:gapadjust{
          margin-top: -$section-block-gap;
        }
      }
    }
    &\:campany{
      .mng-logo{
        max-width: 200px;
        margin-bottom: 24px;
      }
      @include g.footer-breakpoint {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        .mng-logo{
          margin-bottom: 30px;
        }
        p{
          text-align: right;
        }
      }
    }
    &\:copylight{
      width: 100%;

      //gapで足りない分を追加
      margin-top: 16px;
      @include g.footer-breakpoint {
        max-width: 1120px;
      }
    }
  }

  .adjust-line-height {
    line-height: 1.6;
  }
}
.owd-button-pagetop-wrap{
  // 要調整
  position: fixed;
  bottom: 16px;
  right: 32px;
  // z-index: 3;
  z-index: 1;
  @include g.footer-breakpoint {
    bottom: 120px;
    right: 32px;
    width: 60px;
    height: 60px;
  }
}
</style>
